export default __webpack_public_path__ + "static/media/0-VeganRestaurant.ce9eba98.png";